export enum GoogleRedirect {
  REGISTER = 'register',
}